import { useSupabaseSession } from "./useSupabaseSession.mjs";
import { computed } from "#imports";
export const useSupabaseUser = () => {
  const session = useSupabaseSession();
  const userState = computed(() => session.value?.user);
  return userState;
};
